import React from 'react'
import styled from 'styled-components'
import AdSenseAdWrapper from '../../AdSenseAdWrapper'

const css = `
  width: 100%;  
`;
const Elem = styled.ins([css]);
const Wrapper = styled(AdSenseAdWrapper)`
  width: 100%;
`;

export default function MatchedContentAd(props) {
  return <React.Fragment>
    <Wrapper>
      <Elem className="adsbygoogle"
        style={{display:"block", 
           "marginLeft": "auto", "marginRight": "auto"}}
        data-ad-format="autorelaxed"
        data-ad-client="ca-pub-5272980014364481"
        data-matched-content-ui-type="image_stacked,image_stacked"
        data-matched-content-rows-num="2,2"
        data-matched-content-columns-num="2,4"
        data-ad-slot={props.slotId || "4700570526"} >
      </Elem>
    </Wrapper>  
  </React.Fragment>
}
